"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_validator_1 = require("../create-validator");
var getMessage = function (_a) {
    var min = _a.min, max = _a.max, message = _a.message;
    if (message) {
        return message;
    }
    if (max && min) {
        if (max === min) {
            return "Please enter " + max + " characters";
        }
        return "Please enter at least " + min + " and no more than " + max + " characters";
    }
    if (min) {
        return "Please enter at least " + min + " characters";
    }
    return "Please enter no more than " + max + " characters";
};
exports.validLength = function (options) {
    if (!options.min && !options.max) {
        throw new Error("No min or max specified");
    }
    return create_validator_1.createValidator(function (s) {
        return !s
            || ((options.min === undefined || s.length >= options.min) && (options.max === undefined || s.length <= options.max));
    }, getMessage(options));
};
